import type { IconSvgObject } from './types';

const DirectionLeft01Icon: IconSvgObject = [
  ["path", { d: "M8 5L15.5 5V12H8L5.5 8.5L8 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.5 11V21M15.5 3V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.5 21H18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DirectionLeft01Icon;
